export const PaymentReportColumns = [
  // {
  //   id: "customer_payment_actions",
  //   title: "Actions",
  // },
  {
    id: "date",
    title: "Date",
  },
  {
    id: "user_type",
    title: "User Type",
  },
  {
    id: "invoice_no",
    title: "Invoice No",
  },
  {
    id: "name",
    title: "Name",
  },
  {
    id: "payment_type",
    title: "Payment Type", // Will show either "Cash" or "Bank" (1 or 2)
  },
  {
    id: "desc",
    title: "Description",
  },
  {
    id: "amount",
    title: "Amount",
  },
];
